import { Navigate, RouteObject } from "react-router-dom";
import { TimeDesynchronizationPage } from "../pages";

const timeDesynchronizationRoutes: RouteObject[] = [
    {
        path: '/',
        element: <TimeDesynchronizationPage />
    },
    {
        path: '*',
        element: <Navigate to="/" replace />
    }
]

export default timeDesynchronizationRoutes;